import { c as _c } from "react/compiler-runtime";
import { CreditCard, MapPin, Package, Truck } from "lucide-react";
import { orderStatusLabel } from "@osmix/contracts/order-status";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { Order, OrderShipment } from "@/api";
import { SelfDeliverySteps } from "@/components/orders/self-delivery-steps";
import { SellerPickupCard } from "@/components/orders/seller-pickup-card";
import { orderNumber } from "@/components/profile/order-view";
import { carrierName, trackingUrl } from "@/lib/delivery-labels";
import { Price } from "@/components/product/price";
import { useFormatPrice } from "@/lib/use-format-price";
export function OrderReceipt(t0) {
  const $ = _c(118);
  const {
    order,
    shipments: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const shipments = t2;
  const {
    t,
    i18n
  } = useTranslation();
  const fmt = useFormatPrice();
  const t3 = order.createdAt;
  let t4;
  if ($[2] !== order.createdAt) {
    t4 = new Date(order.createdAt).toLocaleString();
    $[2] = order.createdAt;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== order.createdAt || $[5] !== t4) {
    t5 = <p className="type-small text-osmix-icon"><time dateTime={t3}>{t4}</time></p>;
    $[4] = order.createdAt;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== order.id || $[8] !== order.number || $[9] !== t) {
    t6 = t("profile.orderNumber", {
      id: orderNumber(order.id, order.number)
    });
    $[7] = order.id;
    $[8] = order.number;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <h2 className="type-h4 text-osmix-text-1">{t6}</h2>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== order.itemCount || $[14] !== t) {
    t8 = t("cart.items", {
      count: order.itemCount
    });
    $[13] = order.itemCount;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <p className="type-body2 text-osmix-text-2">{t8}</p>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t7 || $[20] !== t9) {
    t10 = <div>{t5}{t7}{t9}</div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== i18n.language || $[23] !== order.status) {
    t11 = orderStatusLabel(order.status, i18n.language);
    $[22] = i18n.language;
    $[23] = order.status;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <span className="self-start rounded-full bg-status-published/10 px-3 py-1 type-small font-bold text-status-published">{t11}</span>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <header className="flex flex-col gap-2 border-b border-osmix-gray-300 pb-4 sm:flex-row sm:items-start sm:justify-between">{t10}{t12}</header>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== fmt || $[31] !== order.groups || $[32] !== shipments || $[33] !== t) {
    let t15;
    if ($[35] !== fmt || $[36] !== shipments || $[37] !== t) {
      t15 = group => {
        const shipment = shipments.find(item => item.shopId === group.shopId);
        return <section key={group.shopId} className="flex flex-col gap-3"><Link to={`/shop/${group.shopSlug}`} className="type-h5 text-osmix-text-1 hover:text-osmix-tangelo">{group.shopName}</Link><ul className="flex flex-col divide-y divide-osmix-gray-300">{group.items.map(item_0 => <li key={`${item_0.productId}-${item_0.variantId ?? item_0.size}`} className="flex items-center gap-3 py-3 first:pt-0"><Link to={`/product/${item_0.productId}`} className="size-14 shrink-0 overflow-hidden rounded-xl bg-osmix-gray-100">{item_0.photo ? <img src={item_0.photo} alt="" className="size-full object-cover" /> : <span className="grid size-full place-items-center text-osmix-icon"><Package className="size-5" aria-hidden="true" /></span>}</Link><div className="min-w-0 flex-1"><p className="type-body2-bold text-osmix-text-1">{item_0.name}</p><p className="type-small text-osmix-icon">{item_0.qty} × {fmt(item_0.unitPrice)}{item_0.variantLabel ? ` · ${item_0.variantLabel}` : item_0.size ? ` · ${item_0.size}` : ""}</p></div><span className="shrink-0 type-body2-bold text-osmix-text-1">{fmt(item_0.lineTotal)}</span></li>)}</ul>{(group.shipment || shipment) && <div className="flex flex-col gap-2 rounded-xl bg-osmix-gray-100 p-4"><div className="flex items-center gap-2 type-body2-bold text-osmix-text-1"><Truck className="size-4 text-osmix-icon" aria-hidden="true" />{t("checkout.delivery")}</div>{group.shipment && <p className="type-small text-osmix-text-2">{group.shipment.tariffName ?? (group.shipment.method ? t(`checkout.deliveryMethods.${group.shipment.method}`) : "")}{group.shipment.deliveryDays ? ` · ${group.shipment.deliveryDays}` : ""}</p>}{group.shipment?.pvzAddress && group.shipment.carrier !== "seller_pickup" && <p className="type-small text-osmix-text-2">{group.shipment.pvzAddress}</p>}{group.shipment?.carrier === "seller_pickup" ? <SellerPickupCard group={group} compact={true} className="bg-transparent p-0" /> : (shipment?.carrier ?? group.shipment?.carrier) === "self" ? <SelfDeliverySteps statusCode={shipment?.statusCode} comment={shipment?.statusHistory.at(-1)?.comment} /> : <>{shipment?.cdekNumber || shipment?.trackingNumber ? <p className="type-small text-osmix-text-2">{carrierName(shipment.carrier)} · {t("checkout.trackingNumber")}:{" "}{trackingUrl(shipment.carrier, shipment.cdekNumber) ? <a href={trackingUrl(shipment.carrier, shipment.cdekNumber)} target="_blank" rel="noreferrer" className="font-bold text-osmix-text-1 underline underline-offset-2">{shipment.cdekNumber}</a> : <strong className="text-osmix-text-1">{shipment.cdekNumber || shipment.trackingNumber}</strong>}</p> : shipment ? <p className="type-small text-osmix-text-2">{t("checkout.shipmentPending")}</p> : null}{shipment?.statusName && <p className="type-small text-osmix-text-2">{t("checkout.shipmentStatus")}: {shipment.statusName}</p>}</>}</div>}</section>;
      };
      $[35] = fmt;
      $[36] = shipments;
      $[37] = t;
      $[38] = t15;
    } else {
      t15 = $[38];
    }
    t14 = order.groups.map(t15);
    $[30] = fmt;
    $[31] = order.groups;
    $[32] = shipments;
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <CreditCard className="size-4 text-osmix-icon" aria-hidden="true" />;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = t("notifications.receipt.payment");
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t16) {
    t17 = <div className="flex items-center gap-2 type-body2-bold text-osmix-text-1">{t15}{t16}</div>;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== order.payment.brand || $[45] !== t) {
    t18 = order.payment.brand || t("profile.paymentMethod");
    $[44] = order.payment.brand;
    $[45] = t;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const t19 = order.payment.last4 ? ` ···· ${order.payment.last4}` : "";
  let t20;
  if ($[47] !== t18 || $[48] !== t19) {
    t20 = <p className="mt-1 type-small text-osmix-text-2">{t18}{t19}</p>;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t17 || $[51] !== t20) {
    t21 = <div className="rounded-xl bg-osmix-gray-100 p-4">{t17}{t20}</div>;
    $[50] = t17;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <MapPin className="size-4 text-osmix-icon" aria-hidden="true" />;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t) {
    t23 = t("profile.deliveryAddress");
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t23) {
    t24 = <div className="flex items-center gap-2 type-body2-bold text-osmix-text-1">{t22}{t23}</div>;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== order.address.city || $[59] !== order.address.country || $[60] !== order.address.postalCode || $[61] !== order.address.street) {
    t25 = <p className="mt-1 type-small text-osmix-text-2">{order.address.country}, {order.address.city}, {order.address.street}, {order.address.postalCode}</p>;
    $[58] = order.address.city;
    $[59] = order.address.country;
    $[60] = order.address.postalCode;
    $[61] = order.address.street;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== order.contact.name || $[64] !== order.contact.phone) {
    t26 = <p className="mt-1 type-small text-osmix-icon">{order.contact.name} · {order.contact.phone}</p>;
    $[63] = order.contact.name;
    $[64] = order.contact.phone;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t24 || $[67] !== t25 || $[68] !== t26) {
    t27 = <div className="rounded-xl bg-osmix-gray-100 p-4">{t24}{t25}{t26}</div>;
    $[66] = t24;
    $[67] = t25;
    $[68] = t26;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== t21 || $[71] !== t27) {
    t28 = <div className="grid gap-3 sm:grid-cols-2">{t21}{t27}</div>;
    $[70] = t21;
    $[71] = t27;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== t14 || $[74] !== t28) {
    t29 = <div className="flex flex-col gap-5 py-5">{t14}{t28}</div>;
    $[73] = t14;
    $[74] = t28;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  let t30;
  if ($[76] !== t) {
    t30 = t("cart.subtotal");
    $[76] = t;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== t30) {
    t31 = <dt className="text-osmix-text-2">{t30}</dt>;
    $[78] = t30;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== fmt || $[81] !== order.subtotal) {
    t32 = fmt(order.subtotal);
    $[80] = fmt;
    $[81] = order.subtotal;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== t32) {
    t33 = <dd>{t32}</dd>;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== t31 || $[86] !== t33) {
    t34 = <div className="flex items-center justify-between">{t31}{t33}</div>;
    $[85] = t31;
    $[86] = t33;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== t) {
    t35 = t("checkout.deliveryFee");
    $[88] = t;
    $[89] = t35;
  } else {
    t35 = $[89];
  }
  let t36;
  if ($[90] !== t35) {
    t36 = <dt className="text-osmix-text-2">{t35}</dt>;
    $[90] = t35;
    $[91] = t36;
  } else {
    t36 = $[91];
  }
  let t37;
  if ($[92] !== fmt || $[93] !== order.deliveryTotal || $[94] !== t) {
    t37 = order.deliveryTotal === 0 ? t("checkout.free") : fmt(order.deliveryTotal);
    $[92] = fmt;
    $[93] = order.deliveryTotal;
    $[94] = t;
    $[95] = t37;
  } else {
    t37 = $[95];
  }
  let t38;
  if ($[96] !== t37) {
    t38 = <dd>{t37}</dd>;
    $[96] = t37;
    $[97] = t38;
  } else {
    t38 = $[97];
  }
  let t39;
  if ($[98] !== t36 || $[99] !== t38) {
    t39 = <div className="flex items-center justify-between">{t36}{t38}</div>;
    $[98] = t36;
    $[99] = t38;
    $[100] = t39;
  } else {
    t39 = $[100];
  }
  let t40;
  if ($[101] !== t) {
    t40 = t("success.total");
    $[101] = t;
    $[102] = t40;
  } else {
    t40 = $[102];
  }
  let t41;
  if ($[103] !== t40) {
    t41 = <dt className="type-h4 text-osmix-text-1">{t40}</dt>;
    $[103] = t40;
    $[104] = t41;
  } else {
    t41 = $[104];
  }
  let t42;
  if ($[105] !== order.total) {
    t42 = <dd><Price value={order.total} size="lg" /></dd>;
    $[105] = order.total;
    $[106] = t42;
  } else {
    t42 = $[106];
  }
  let t43;
  if ($[107] !== t41 || $[108] !== t42) {
    t43 = <div className="mt-1 flex items-center justify-between border-t border-osmix-gray-300 pt-3">{t41}{t42}</div>;
    $[107] = t41;
    $[108] = t42;
    $[109] = t43;
  } else {
    t43 = $[109];
  }
  let t44;
  if ($[110] !== t34 || $[111] !== t39 || $[112] !== t43) {
    t44 = <dl className="flex flex-col gap-2 border-t border-osmix-gray-300 pt-4 type-body2">{t34}{t39}{t43}</dl>;
    $[110] = t34;
    $[111] = t39;
    $[112] = t43;
    $[113] = t44;
  } else {
    t44 = $[113];
  }
  let t45;
  if ($[114] !== t13 || $[115] !== t29 || $[116] !== t44) {
    t45 = <article className="w-full rounded-2xl bg-card p-5 text-left shadow-block sm:p-6" data-testid="order-receipt">{t13}{t29}{t44}</article>;
    $[114] = t13;
    $[115] = t29;
    $[116] = t44;
    $[117] = t45;
  } else {
    t45 = $[117];
  }
  return t45;
}